import type { GenerationJob } from '@studio/contract';
import { useQuery } from '@tanstack/react-query';
import { useStudioClient } from '../context';
import { parseApiError } from '../errors';

/**
 * `GET /api/generations` — most recent 50 generations for the workspace.
 * Used by Gallery to render `kind=draft` tiles alongside product images.
 */
export function useGenerations() {
  const client = useStudioClient();
  return useQuery({
    queryKey: ['generations'],
    queryFn: async () => {
      const res = await client.api.generations.$get();
      if (!res.ok) throw await parseApiError(res);
      const data = (await res.json()) as { items: GenerationJob[] };
      return data;
    },
  });
}
